export class ApplicationLeadApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLeadDataByApplication({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/lead`);
  }

  async editLeadByApplicationId({ applicationId, isTest, reassignLoanOfficer, ...body }) {
    return this.#http.put(`/application/${applicationId}/lead`, body, {
      params: { isTest, reassignLoanOfficer },
    });
  }

  async getLeadFeesDataByApplication({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/lead/fees-data`);
  }

  // FH-189: v2 returns { applicationId, loanOfficer } so the caller can warn the creator when licensure
  // blocked their Loan Officer placement; v1 returns only the id.
  async createLead({ isTest, subCompanyId, ...body }) {
    return this.#http.post('/application/lead/v2', body, {
      params: { isTest, subCompanyId },
    });
  }

  async importLeads(body) {
    return this.#http.post('/application/leads/import', body);
  }

  async checkLeadsImport(body) {
    return this.#http.post('/application/leads/import/check', body);
  }

  async getLeadsImportStatus(traceId) {
    return this.#http.get(`/application/leads/import/${traceId}`);
  }

  async convertLeadToLoan(applicationId, dto) {
    return this.#http.post(`/application/lead/${applicationId}/convert-to-loan`, dto);
  }
}
